import script from "./SaturdayShipmentPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SaturdayShipmentPopup.vue?vue&type=script&setup=true&lang=js"

import "./SaturdayShipmentPopup.vue?vue&type=style&index=0&id=02273500&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02273500"]])

export default __exports__